module.exports = __webpack_public_path__ + "static/media/text-height.fd7af798.svg";